import { IconButton, InputAdornment } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import React from 'react'

interface ClearAdornmentProps {
  onClick: () => void
  disabled: boolean
}

export const ClearAdornment: React.FC<ClearAdornmentProps> = ({
  onClick,
  disabled
}) => {
  return (
    <InputAdornment position='end'>
      <IconButton disabled={disabled} onClick={onClick}>
        <ClearIcon />
      </IconButton>
    </InputAdornment>
  )
}
